var cilArrowBottom = ["512 512", "<path fill='var(--ci-primary-color, currentcolor)' d='m367.997 338.75-95.998 95.997V17.503h-32v417.242l-95.996-95.995-22.627 22.627L256 496l134.624-134.623z' class='ci-primary'/>"];

export { cilArrowBottom };
//# sourceMappingURL=cil-arrow-bottom.js.map
